import { glowQuestions, shindenQuestions } from '../utils/pet-question'

const glowKeys = Object.keys(glowQuestions)
const shindenKeys = Object.keys(shindenQuestions)
const clearedShindenQuestions = Object.entries(shindenQuestions).reduce((acc, [key, value]) => {
  acc[key] = Array.isArray(value) ? [] : typeof value === 'string' ? '' : value
  return acc
}, {})

const stringFields = ['marriage', 'homeAddress', 'workingAddress', 'email', 'reasonsForShinden', 'wackUpTime', 'sleepTime', 'holidays', 'height', 'weight', 'beautyExpenses']

export default {
  data() {
    return {
      pregnant: [], // 備孕/懷孕
      livinCondition: [], // 生活狀況
      healthStatus: [], // 健康狀態
      skinCondition: [], // 肌膚狀態
      historyOfSurgery: [], // 有無開刀史
      skinType: [], // 膚質
      sunProtectionStatus: [], // 防曬狀況
      sunProtectionHabits: [], // 防曬習慣
      makeupRemoverType: [], // 卸妝產品類型
      skinCareProductsUsed: [], // 使用的保養品
      recentMedicalTreatment: [], // 近期醫美療程
      skinProblemYouWantToSolve: [], // 希望解決的肌膚問題
      bodyConditionForBeauty: [
        {
          text: '備孕/懷孕',
          key: 'pregnant',
        },
        {
          text: '生活狀況',
          key: 'livinCondition',
        },
        {
          text: '健康狀態',
          key: 'healthStatus',
        },
        {
          text: '肌膚狀態',
          key: 'skinCondition',
        },
        {
          text: '有無開刀史',
          key: 'historyOfSurgery',
        },
      ],
      bodyConditionForMassage: [
        { text: '病史', key: 'medicalHistory' },
        { text: '休閒運動種類', key: 'typesOfRecreationalSports' },
        { text: '訓練或運動量', key: 'trainingVolume' },
        { text: '希望改善部位', key: 'desiredImprovementAreas' },
        { text: '是否有任何種類按摩經驗', key: 'massageExperience' },
        { text: '希望按摩力道', key: 'massageIntensityPreference' },
      ],
      skinConditionDemo: [
        {
          text: '膚質',
          key: 'skinType',
        },
        {
          text: '防曬狀況',
          key: 'sunProtectionStatus',
        },
        {
          text: '防曬習慣',
          key: 'sunProtectionHabits',
        },
        {
          text: '卸妝產品類型',
          key: 'makeupRemoverType',
        },
        {
          text: '使用的保養品',
          key: 'skinCareProductsUsed',
        },
        {
          text: '近期醫美療程',
          key: 'recentMedicalTreatment',
        },
        {
          text: '希望解決的肌膚問題',
          key: 'skinProblemYouWantToSolve',
        },
      ],
      // glow
      marriage: '',
      DM: [],
      job: [],
      workingAddress: '',
      reasons: [],
      disease: [],
      pressure: [],
      allergy: [],
      medicine: [],
      sleepQuality: [],
      eatingHabits: [],
      purposes: [],
      scalpProblemRecently: [],
      hairProblem: [],
      hairWashFrequency: [],
      oilyScalpProblem: [],
      dandruffProblem: [],
      scalpProblemPast: [],
      hairCareProducts: [],
      hasScalpCareService: [],
      // 心傳
      ...clearedShindenQuestions,
      defaultFormMapping: [
        'behavior',
        'healthy',
        'pregnant',
        'livinCondition',
        'healthStatus',
        'skinCondition',
        'historyOfSurgery',
        'skinType',
        'sunProtectionStatus',
        'sunProtectionHabits',
        'makeupRemoverType',
        'skinCareProductsUsed',
        'recentMedicalTreatment',
        'skinProblemYouWantToSolve',
      ],
      glowFormMapping: glowKeys,
      shindenFormMapping: shindenKeys,
      memberInfoForGlow: [
        {
          text: '婚姻狀況',
          key: 'marriage',
        },
        {
          text: '住址',
          key: 'homeAddress',
        },
        {
          text: '電子信箱',
          key: 'email',
        },
        {
          text: '是否希望收到DM',
          key: 'DM',
        },
        {
          text: '職業',
          key: 'job',
        },
        {
          text: '工作地址',
          key: 'workingAddress',
        },
        {
          text: '來店契機',
          key: 'reasons',
        },
      ],
      bodyConditionForGlow: [
        {
          text: '健康狀態',
          key: 'healthStatus',
        },
        {
          text: '體質/疾病',
          key: 'disease',
        },
        {
          text: '近期壓力',
          key: 'pressure',
        },
        {
          text: '過敏',
          key: 'allergy',
        },
        {
          text: '服用藥物',
          key: 'medicine',
        },
        {
          text: '睡眠品質',
          key: 'sleepQuality',
        },
        {
          text: '飲食習慣',
          key: 'eatingHabits',
        },
      ],
      customerHistoryForGlow: [
        {
          text: '來店目的',
          key: 'purposes',
        },
        {
          text: '頭皮狀況',
          key: 'scalpProblemRecently',
        },
        {
          text: '頭髮狀況',
          key: 'hairProblem',
        },
        {
          text: '平常洗髮頻率',
          key: 'hairWashFrequency',
        },
        {
          text: '頭皮出油',
          key: 'oilyScalpProblem',
        },
        {
          text: '頭皮屑狀況',
          key: 'dandruffProblem',
        },
        {
          text: '過去頭皮狀況',
          key: 'scalpProblemPast',
        },
        {
          text: '洗護產品',
          key: 'hairCareProducts',
        },
        {
          text: '專業頭皮護理',
          key: 'hasScalpCareService',
        },
        {
          text: '備注',
          key: 'remark',
        },
      ],
      shindenForHair: [
        {
          text: '目前狀況',
          key: 'medicalHistory',
        },
        {
          text: '正接受疾病治療',
          key: 'curingForHair',
        },
        {
          text: '服用藥物',
          key: 'medicationStatusForHair',
        },
        {
          text: '健康狀態',
          key: 'healthStatusForHair',
        },
        {
          text: '生理期狀態',
          key: 'menstrualPeriodStatusForHair',
        },
      ],
      shindenForFace: [
        {
          text: '健康狀態',
          key: 'healthStatusForHand',
        },
        {
          text: '生理期狀態',
          key: 'menstrualPeriodStatusForHand',
        },
        {
          text: '生理痛狀態',
          key: 'menstrualPainForHand',
        },
        {
          text: '過敏狀態',
          key: 'allergyForHand',
        },
        {
          text: '治療中疾病',
          key: 'curingForHand',
        },
      ],
      shindenForHand: [
        {
          text: '健康狀態',
          key: 'healthStatusForHand',
        },
        {
          text: '生理期狀態',
          key: 'menstrualPeriodStatusForHand',
        },
        {
          text: '生理痛狀態',
          key: 'menstrualPainForHand',
        },
        {
          text: '壓力狀態',
          key: 'pressureStatus',
        },
        {
          text: '治療中疾病',
          key: 'curingForHand',
        },
      ],
    }
  },
  computed: {
    composeQToArr() {
      const res = this.targetMappingArray.reduce((acc, cur) => {
        const value = stringFields.includes(cur) ? '' : []
        acc[cur] = value
        return acc
      }, {})
      return res
    },
    targetMappingArray() {
      const alias = this.currentStoreAlias

      const formMapping = {
        'glow-headspa': this.glowFormMapping,
        shinden: this.shindenFormMapping,
      }

      return formMapping[alias] || this.defaultFormMapping
    },
  },
}
